export const COURT_APPEARANCE_TYPES = {
  "Children's Court (Summary)": [
    { label: "Lump sum preparation fee" },
    { label: "Lump sum preparation fee (urgent)" },
    { label: "Lump sum consolidated preparation fee" },
    { label: "Lump sum consolidated preparation fee (urgent)" },
    { label: "Mention" },
    { label: "Contest Mention" },
    { label: "Contest" },
    { label: "Plea" },
    { label: "Sentence" },
    { label: "Bail Application" },
    { label: "Bail Application Preparation Fee" },
    { label: "Group Conference (Work Hours)" },
    { label: "Group Conference (After Hours)" },
    { label: "Youth Control Order Planning Meeting" },
    { label: "Youth Control Order Reporting/Monitoring Hearing" },
    { label: "Youth Control Order Variation Opposed" },
    { label: "Breach/Revocation of Youth Control Order" },
    { label: "Application for Summary Jurisdiction" },
    { label: "Committal Mention" },
    { label: "Contested Committal Day 1" },
    { label: "Contested Committal Day 2" },
    { label: "Special Mention" },
    { label: "Daily appearance fee" },
    { label: "Daily appearance fee (consolidation)" },
    { label: "Appearance on sentence or adjournment (consolidation)" },
    { label: "Contest Mention (consolidation)" },
    { label: "Plea heard at contest mention – contest mention fee" },
    { label: "Plea heard at contest mention – contest mention fee (consolidation)" },
    { label: "Plea heard at contest mention – plea fee" },
    { label: "Plea heard at contest mention – plea fee (consolidation)" },
    { label: "Other" }
  ],
  "Children's Court (Serious Indictable)": [
    { label: "Lump sum preparation fee" },
    { label: "Contest mention" },
    { label: "Appearance fee" },
    { label: "Application for summary jurisdiction" },
    { label: "Group conference held during work hours" },
    { label: "Group conference held after work hours" },
    { label: "Youth Control Order planning meeting" },
    { label: "Youth Control Order reporting and monitoring hearing" },
    { label: "Youth Control Order reporting and monitoring hearing to oppose variation" },
    { label: "Breach or Revocation of a Youth Control Order" },
    { label: "Sentence" },
    { label: "Other" }
  ],
  "Magistrates Court": [
    { label: "Lump sum preparation fee" },
    { label: "Lump sum preparation fee (urgent)" },
    { label: "Lump sum consolidated preparation fee" },
    { label: "Lump sum consolidated preparation fee (urgent)" },
    { label: "Mention" },
    { label: "Further Mention" },
    { label: "Special Mention" },
    { label: "Contest Mention" },
    { label: "Contest" },
    { label: "Plea" },
    { label: "Sentence" },
    { label: "Return for Sentence" },
    { label: "Bail Application" },
    { label: "Bail Application Preparation Fee" },
    { label: "Committal Mention" },
    { label: "Contested Committal Day 1" },
    { label: "Contested Committal Day 2" },
    { label: "Committal Resolving as Plea" },
    { label: "Sentence Indication" },
    { label: "Ground Rules Hearing" },
    { label: "CISP/Drug Court Mention" },
    { label: "ARC ISP Ratification Hearing" },
    { label: "ARC Review" },
    { label: "Daily appearance fee" },
    { label: "Daily appearance fee (consolidation)" },
    { label: "Appearance on sentence or adjournment (consolidation)" },
    { label: "Contest Mention (consolidation)" },
    { label: "Plea heard at contest mention – contest mention fee" },
    { label: "Plea heard at contest mention – contest mention fee (consolidation)" },
    { label: "Plea heard at contest mention – plea fee" },
    { label: "Plea heard at contest mention – plea fee (consolidation)" },
    { label: "Other" }
  ],
  "County Court": [
    { label: "First Directions Hearing" },
    { label: "Directions Hearing / Mention / Callover" },
    { label: "Case Conference" },
    { label: "Bail Application" },
    { label: "Bail Application Preparation Fee" },
    { label: "Bail Application Mention / Adjournment" },
    { label: "Plea" },
    { label: "First day plea (resolves at trial stage)" },
    { label: "Subsequent day plea (resolves at trial stage)" },
    { label: "Trial (first day)" },
    { label: "Trial (first day - 20% uplift applicable)" },
    { label: "Trial (subsequent day)" },
    { label: "Sentence" },
    { label: "Return for Sentence" },
    { label: "Sentence Indication" },
    { label: "Subsequent day Sentence Indication" },
    { label: "Sentence Appeal Appearance" },
    { label: "Conviction and Sentence Appeal Daily Appearance" },
    { label: "Appeal Mention" },
    { label: "CMIA Appearance and conference" },
    { label: "CMIA Mention" },
    { label: "CMIA Judgement" },
    { label: "CMIA Hearing (first day)" },
    { label: "CMIA Hearing (subsequent day)" },
    { label: "Fitness Investigation Day 1" },
    { label: "Fitness Investigation Subsequent Day" },
    { label: "SOA Supervision Order Mention / directions" },
    { label: "SOA Supervision Order Hearing (first day)" },
    { label: "SOA Supervision Order Hearing (subsequent day)" },
    { label: "SOA Review Hearing" },
    { label: "SOA Review Mention / directions" },
    { label: "SOA Review Judgement" },
    { label: "Breach Matter Preparation Fee" },
    { label: "Breach Matter Mention" },
    { label: "Breach Matter Daily Appearance" },
    { label: "Breach Matter Sentence" },
    { label: "Special hearing (first day)" },
    { label: "Special hearing (subsequent day)" },
    { label: "Ground Rules Hearing" },
    { label: "Section 198A Application for hearing" },
    { label: "Section 198A Pre-trial examination" },
    { label: "Case Initiation Notice" },
    { label: "ACMS Prep for case conference (instructor)" },
    { label: "ACMS Counsel prep for case conference" },
    { label: "Trial Readiness Questionnaire Certificate" },
    { label: "Case assessment hearing" },
    { label: "Post-committal negotiations" },
    { label: "Defence response – first directions hearing" },
    { label: "Application for discontinuance of proceedings" },
    { label: "Defence response – final directions hearing" },
    { label: "Conference with co-counsel (TCDP)" },
    { label: "Other" }
  ],
  "Supreme Court": [
    { label: "First Directions Hearing" },
    { label: "Directions Hearing / Mention / Callover" },
    { label: "Bail Application" },
    { label: "Bail Application Preparation Fee" },
    { label: "Plea" },
    { label: "First day plea (resolves at trial stage)" },
    { label: "Subsequent day plea (resolves at trial stage)" },
    { label: "Trial (first day)" },
    { label: "Trial (first day - 20% uplift applicable)" },
    { label: "Trial (subsequent day)" },
    { label: "Sentence" },
    { label: "Return for Sentence" },
    { label: "Sentence Indication" },
    { label: "Subsequent day Sentence Indication" },
    { label: "CMIA Appearance and conference" },
    { label: "CMIA Mention" },
    { label: "CMIA Judgement" },
    { label: "CMIA Hearing (first day)" },
    { label: "CMIA Hearing (subsequent day)" },
    { label: "Fitness Investigation Day 1" },
    { label: "Fitness Investigation Subsequent Day" },
    { label: "SOA Emergency Detention Order Hearing" },
    { label: "SOA Emergency Detention Order Mention / directions" },
    { label: "SOA Emergency Detention Order Judgement" },
    { label: "SOA Detention Order Mention / directions" },
    { label: "SOA Detention Order Hearing (first day)" },
    { label: "SOA Detention Order Hearing (subsequent day)" },
    { label: "SOA Detention Order Judgement" },
    { label: "SOA Supervision Order Mention / directions" },
    { label: "SOA Supervision Order Hearing (first day)" },
    { label: "SOA Supervision Order Hearing (subsequent day)" },
    { label: "SOA Supervision Order Judgement" },
    { label: "SOA Review Hearing" },
    { label: "SOA Review Mention / directions" },
    { label: "SOA Review Judgement" },
    { label: "Breach Matter Preparation Fee" },
    { label: "Breach Matter Mention" },
    { label: "Breach Matter Daily Appearance" },
    { label: "Breach Matter Sentence" },
    { label: "Special hearing (first day)" },
    { label: "Special hearing (subsequent day)" },
    { label: "Ground Rules Hearing" },
    { label: "Application to cross-examine witnesses – s198B" },
    { label: "Appearance where witnesses cross-examined – s198B" },
    { label: "Counsel prep for administrative callover" },
    { label: "Case conference" },
    { label: "Post-committal negotiations" },
    { label: "Defence response – first directions hearing" },
    { label: "Application for discontinuance of proceedings" },
    { label: "Defence response – final directions hearing" },
    { label: "Conference with co-counsel (TCDP)" },
    { label: "Other" }
  ],
  "Court of appeal": [
    { label: "Oral hearing (exceptional circumstances)" },
    { label: "Election to renew – Brief fee (first day)" },
    { label: "Election to renew – Subsequent day" },
    { label: "Election to renew – Appearance at judgment" },
    { label: "Appeal against sentence – Brief fee" },
    { label: "Appeal against sentence – Subsequent day" },
    { label: "Appeal against sentence – Appearance at judgment" },
    { label: "Appeal against conviction/conviction & sentence – Brief fee" },
    { label: "Appeal against conviction/conviction & sentence – Subsequent day" },
    { label: "Appeal against conviction/conviction & sentence – Appearance at judgment" },
    { label: "Leave application – Preparation" },
    { label: "Drawing grounds of appeal & written case (conviction / conviction & sentence)" },
    { label: "Drawing grounds of appeal & written case (sentence only)" },
    { label: "Revision of grounds of appeal" },
    { label: "Application for renewal" },
    { label: "Election to renew – Preparation" },
    { label: "Perusal of leave application & drawing revised grounds of appeal" },
    { label: "Appeal against sentence – Solicitor preparation" },
    { label: "Appeal against conviction – Solicitor preparation" },
    { label: "Other" }
  ],
  "High Court": [
    { label: "Application for Special Leave" },
    { label: "Appeal" },
    { label: "Other" }
  ],
  "Office of Chief Examiner": [
    { label: "Examination" },
    { label: "Other" }
  ],
  "Other": [
    { label: "Mention" },
    { label: "Hearing" },
    { label: "Other" }
  ]
};

const APPEARANCE_MATTER_TYPES = {
  "Mention": [{ label: "Criminal" }, { label: "Family Violence Intervention Order" }, { label: "Personal Safety Intervention Order" }, { label: "Other" }],
  "Lump sum preparation fee": [{ label: "Criminal" }, { label: "Other" }],
  "Lump sum preparation fee (urgent)": [{ label: "Criminal" }, { label: "Other" }],
  "Lump sum consolidated preparation fee": [{ label: "Criminal" }, { label: "Other" }],
  "Lump sum consolidated preparation fee (urgent)": [{ label: "Criminal" }, { label: "Other" }],
  "Further Mention": [{ label: "Criminal" }, { label: "Family Violence Intervention Order" }, { label: "Personal Safety Intervention Order" }, { label: "Other" }],
  "Hearing (Summary Crime)": [{ label: "Criminal" }, { label: "Other" }],
  "Contest Mention": [{ label: "Criminal" }, { label: "Other" }],
  "Bail Application": [{ label: "Criminal" }, { label: "Other" }],
  "Bail Application Preparation Fee": [{ label: "Criminal" }, { label: "Other" }],
  "Bail Application Mention / Adjournment": [{ label: "Criminal" }, { label: "Other" }],
  "Breach Matter Preparation Fee": [{ label: "Criminal" }, { label: "Other" }],
  "Breach Matter Mention": [{ label: "Criminal" }, { label: "Other" }],
  "Breach Matter Daily Appearance": [{ label: "Criminal" }, { label: "Other" }],
  "Breach Matter Sentence": [{ label: "Criminal" }, { label: "Other" }],
  "Committal Mention": [{ label: "Criminal" }, { label: "Other" }],
  "Committal Hearing": [{ label: "Criminal — Contested" }, { label: "Criminal — Uncontested" }, { label: "Other" }],
  "Contested Committal First Day": [{ label: "Criminal" }, { label: "Other" }],
  "Contested Committal Day 1": [{ label: "Criminal" }, { label: "Other" }],
  "Contested Committal Day 2": [{ label: "Criminal" }, { label: "Other" }],
  "Plea": [{ label: "Criminal" }, { label: "Family Violence Intervention Order" }, { label: "Personal Safety Intervention Order" }, { label: "Other" }],
  "First day plea (resolves at trial stage)": [{ label: "Criminal" }, { label: "Other" }],
  "Subsequent day plea (resolves at trial stage)": [{ label: "Criminal" }, { label: "Other" }],
  "Contest": [{ label: "Criminal" }, { label: "Family Violence Intervention Order" }, { label: "Personal Safety Intervention Order" }, { label: "Other" }],
  "Trial": [{ label: "Criminal" }, { label: "Other" }],
  "Sentence": [{ label: "Criminal" }, { label: "Other" }],
  "Return for Sentence": [{ label: "Criminal" }, { label: "Other" }],
  "First Directions Hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Directions Hearing": [{ label: "Criminal" }, { label: "Family Violence Intervention Order" }, { label: "Personal Safety Intervention Order" }, { label: "Other" }],
  "Directions Hearing / Mention / Callover": [{ label: "Criminal" }, { label: "Other" }],
  "Case Assessment Hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Case Conference": [{ label: "Criminal" }, { label: "Other" }],
  "Filing Hearing": [{ label: "Criminal" }, { label: "Other" }],
  "ARC Review": [{ label: "Drug Court" }, { label: "Other" }],
  "Sentence Indication": [{ label: "Criminal" }, { label: "Other" }],
  "Subsequent day Sentence Indication": [{ label: "Criminal" }, { label: "Other" }],
  "Trial (first day)": [{ label: "Criminal" }, { label: "Other" }],
  "Trial (first day - 20% uplift applicable)": [{ label: "Criminal" }, { label: "Other" }],
  "Trial (subsequent day)": [{ label: "Criminal" }, { label: "Other" }],
  "Appeal": [{ label: "Criminal" }, { label: "Other" }],
  "Appeal from Magistrates Court": [{ label: "Criminal" }, { label: "Other" }],
  "CMIA Appearance and conference": [{ label: "Criminal" }, { label: "Other" }],
  "CMIA Mention": [{ label: "Criminal" }, { label: "Other" }],
  "CMIA Judgement": [{ label: "Criminal" }, { label: "Other" }],
  "CMIA Hearing (first day)": [{ label: "Criminal" }, { label: "Other" }],
  "CMIA Hearing (subsequent day)": [{ label: "Criminal" }, { label: "Other" }],
  "Fitness Investigation Day 1": [{ label: "Criminal" }, { label: "Other" }],
  "Fitness Investigation Subsequent Day": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Emergency Detention Order Hearing": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Emergency Detention Order Mention / directions": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Emergency Detention Order Judgement": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Detention Order Mention / directions": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Detention Order Hearing (first day)": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Detention Order Hearing (subsequent day)": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Detention Order Judgement": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Supervision Order Mention / directions": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Supervision Order Hearing (first day)": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Supervision Order Hearing (subsequent day)": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Supervision Order Judgement": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Review Hearing": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Review Mention / directions": [{ label: "Criminal" }, { label: "Other" }],
  "SOA Review Judgement": [{ label: "Criminal" }, { label: "Other" }],
  "Application for Leave to Appeal": [{ label: "Criminal" }, { label: "Other" }],
  "Application for Special Leave": [{ label: "Criminal" }, { label: "Other" }],
  "Examination": [{ label: "Other" }],
  "Hearing": [{ label: "Other" }],
  "Special hearing (first day)": [{ label: "Criminal" }, { label: "Other" }],
  "Special hearing (subsequent day)": [{ label: "Criminal" }, { label: "Other" }],
  "Ground Rules Hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Section 198A Application for hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Section 198A Pre-trial examination": [{ label: "Criminal" }, { label: "Other" }],
  "Case Initiation Notice": [{ label: "Criminal" }, { label: "Other" }],
  "ACMS Prep for case conference (instructor)": [{ label: "Criminal" }, { label: "Other" }],
  "ACMS Counsel prep for case conference": [{ label: "Criminal" }, { label: "Other" }],
  "Trial Readiness Questionnaire Certificate": [{ label: "Criminal" }, { label: "Other" }],
  "Case assessment hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Application to cross-examine witnesses – s198B": [{ label: "Criminal" }, { label: "Other" }],
  "Appearance where witnesses cross-examined – s198B": [{ label: "Criminal" }, { label: "Other" }],
  "Counsel prep for administrative callover": [{ label: "Criminal" }, { label: "Other" }],
  "Case conference": [{ label: "Criminal" }, { label: "Other" }],
  "Post-committal negotiations": [{ label: "Criminal" }, { label: "Other" }],
  "Defence response – first directions hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Application for discontinuance of proceedings": [{ label: "Criminal" }, { label: "Other" }],
  "Defence response – final directions hearing": [{ label: "Criminal" }, { label: "Other" }],
  "Conference with co-counsel (TCDP)": [{ label: "Criminal" }, { label: "Other" }],
  "Other": [{ label: "Other" }],
};

const APPEARANCE_FEE_LOOKUP = {
  "Children's Court (Summary)": {
    "Lump sum preparation fee": {
      fee: 484,
      feeType: "Lump sum preparation fee",
      table: "Table A",
      note: "Covers all necessary preparation work.",
    },
    "Lump sum preparation fee (urgent)": {
      fee: 277,
      feeType: "Lump sum preparation fee (urgent)",
      table: "Table A",
      note: "Urgent grant preparation fee.",
    },
    "Lump sum consolidated preparation fee": {
      fee: 579,
      feeType: "Lump sum consolidated preparation fee",
      table: "Table A",
      note: "Consolidated grant preparation fee (single accused).",
    },
    "Lump sum consolidated preparation fee (urgent)": {
      fee: 348,
      feeType: "Lump sum consolidated preparation fee (urgent)",
      table: "Table A",
      note: "Urgent consolidated grant preparation fee (single accused).",
    },
    "Mention": {
      fee: 185,
      feeType: "Appearance at mention hearing",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Contest Mention": {
      fee: 332,
      feeType: "Contest mention",
      table: "Table A",
      note: "Single accused summary rate for each necessary appearance.",
    },
    "Contest": {
      fee: 1099,
      feeType: "Contest hearing appearance",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Plea": {
      fee: 318,
      feeType: "Plea of guilty",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Sentence": {
      fee: 318,
      feeType: "Appearance on sentence or adjournment",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Bail Application": {
      fee: 557,
      feeType: "Appearance fee",
      table: "Table B",
      note: "Children's Court or Magistrates' Court bail application. $557 from 19 Oct 2026 (was $484).",
    },
    "Bail Application Preparation Fee": {
      fee: 362,
      feeType: "Contested bail preparation",
      table: "Table B",
      note: "Children's Court or Magistrates' Court bail application. $362 from 19 Oct 2026 (was $226).",
    },
    "Group Conference (Work Hours)": {
      fee: 464,
      feeType: "Group conference held during work hours",
      table: "Table A",
      note: "Children's Court only.",
    },
    "Group Conference (After Hours)": {
      fee: 594,
      feeType: "Group conference held outside work hours",
      table: "Table A",
      note: "Children's Court only.",
    },
    "Youth Control Order Planning Meeting": {
      fee: 358,
      feeType: "Youth Control Order planning meeting",
      table: "Table A",
      note: "Children's Court only.",
    },
    "Youth Control Order Reporting/Monitoring Hearing": {
      fee: 185,
      feeType: "Youth Control Order reporting and monitoring hearing",
      table: "Table A",
      note: "Children's Court only.",
    },
    "Youth Control Order Variation Opposed": {
      fee: 318,
      feeType: "Youth Control Order reporting and monitoring hearing to oppose variation",
      table: "Table A",
      note: "Oppose variation to significantly more restrictive order. Children's Court only.",
    },
    "Breach/Revocation of Youth Control Order": {
      fee: 484,
      feeType: "Breach or Revocation of a Youth Control Order",
      table: "Table A",
      note: "Children's Court only.",
    },
    "Application for Summary Jurisdiction": {
      fee: 890,
      feeType: "Application for summary jurisdiction",
      table: "Table A",
      note: "Children's Court only.",
    },
    "Committal Mention": {
      fee: 445,
      feeType: "Appearance committal mention/case conference",
      table: "Table E",
      note: "Children's or Magistrates' Court stage.",
    },
    "Contested Committal Day 1": {
      fee: 1284,
      feeType: "Appearance on contested committal: day 1",
      table: "Table E",
      note: "Day 1 rate for an indictable committal.",
    },
    "Contested Committal Day 2": {
      fee: 1157,
      feeType: "Appearance on contested committal: day 2",
      table: "Table E",
      note: "Day 2 rate for an indictable committal.",
    },
    "Special Mention": {
      fee: 185,
      feeType: "Appearance at special mention",
      table: "Table A",
      note: "Single accused rate.",
    },
    "Daily appearance fee": {
      fee: 484,
      feeType: "Daily appearance fee",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Daily appearance fee (consolidation)": {
      fee: 579,
      feeType: "Daily appearance fee (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    },
    "Appearance on sentence or adjournment (consolidation)": {
      fee: 369,
      feeType: "Appearance on sentence or adjournment (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    },
    "Contest Mention (consolidation)": {
      fee: 581,
      feeType: "Consolidated contest mention fee",
      table: "Table A",
      note: "More than one contest mention listed that meets guidelines.",
    },
    "Plea heard at contest mention – contest mention fee": {
      fee: 332,
      feeType: "Plea heard at contest mention – contest mention fee",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Plea heard at contest mention – contest mention fee (consolidation)": {
      fee: 581,
      feeType: "Plea heard at contest mention – contest mention fee (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    },
    "Plea heard at contest mention – plea fee": {
      fee: 318,
      feeType: "Plea heard at contest mention – plea fee",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Plea heard at contest mention – plea fee (consolidation)": {
      fee: 369,
      feeType: "Plea heard at contest mention – plea fee (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    }
  },
  "Children's Court (Serious Indictable)": {
    "Lump sum preparation fee": {
      fee: 719,
      feeType: "The lump sum preparation fee",
      table: "Table F(i)",
      note: "Covers all necessary work."
    },
    "Contest mention": {
      fee: 356,
      feeType: "Contest mention appearance fee",
      table: "Table F(i)",
      note: "Payable under specific guidelines."
    },
    "Appearance fee": {
      fee: 1214,
      feeType: "Appearance fee",
      table: "Table F(i)",
      note: "For each day or part day."
    },
    "Application for summary jurisdiction": {
      fee: 890,
      feeType: "Application for summary jurisdiction",
      table: "Table F(i)",
      note: "Serious indictable Children's Court stage."
    },
    "Group conference held during work hours": {
      fee: 534,
      feeType: "Group conference held during work hours",
      table: "Table F(i)",
      note: "Children's Court only."
    },
    "Group conference held after work hours": {
      fee: 712,
      feeType: "Group conference held after work hours",
      table: "Table F(i)",
      note: "Children's Court only."
    },
    "Youth Control Order planning meeting": {
      fee: 358,
      feeType: "Youth Control Order planning meeting",
      table: "Table F(i)",
      note: "Children's Court only."
    },
    "Youth Control Order reporting and monitoring hearing": {
      fee: 185,
      feeType: "Youth Control Order reporting and monitoring hearing",
      table: "Table F(i)",
      note: "Children's Court only."
    },
    "Youth Control Order reporting and monitoring hearing to oppose variation": {
      fee: 318,
      feeType: "Youth Control Order reporting and monitoring hearing to oppose variation",
      table: "Table F(i)",
      note: "Children's Court only."
    },
    "Breach or Revocation of a Youth Control Order": {
      fee: 484,
      feeType: "Breach or Revocation of a Youth Control Order",
      table: "Table F(i)",
      note: "Children's Court only."
    },
    "Sentence": {
      fee: 358,
      feeType: "Appearance on sentence",
      table: "Table F(i)",
      note: "If on a different day."
    }
  },
  "Magistrates Court": {
    "Lump sum preparation fee": {
      fee: 484,
      feeType: "Lump sum preparation fee",
      table: "Table A",
      note: "Covers all necessary preparation work.",
    },
    "Lump sum preparation fee (urgent)": {
      fee: 277,
      feeType: "Lump sum preparation fee (urgent)",
      table: "Table A",
      note: "Urgent grant preparation fee.",
    },
    "Lump sum consolidated preparation fee": {
      fee: 579,
      feeType: "Lump sum consolidated preparation fee",
      table: "Table A",
      note: "Consolidated grant preparation fee (single accused).",
    },
    "Lump sum consolidated preparation fee (urgent)": {
      fee: 348,
      feeType: "Lump sum consolidated preparation fee (urgent)",
      table: "Table A",
      note: "Urgent consolidated grant preparation fee (single accused).",
    },
    "Mention": {
      fee: 185,
      feeType: "Appearance at mention hearing",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Further Mention": {
      fee: 185,
      feeType: "Appearance at mention hearing",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Special Mention": {
      fee: 185,
      feeType: "Appearance at special mention",
      table: "Table A",
      note: "Single accused rate.",
    },
    "Contest Mention": {
      fee: 332,
      feeType: "Contest mention",
      table: "Table A",
      note: "Single accused summary rate for each necessary appearance.",
    },
    "Bail Application": {
      fee: 557,
      feeType: "Appearance fee",
      table: "Table B",
      note: "Children's Court or Magistrates' Court bail application. $557 from 19 Oct 2026 (was $484).",
    },
    "Bail Application Preparation Fee": {
      fee: 362,
      feeType: "Contested bail preparation",
      table: "Table B",
      note: "Children's Court or Magistrates' Court bail application. $362 from 19 Oct 2026 (was $226).",
    },
    "Committal Mention": {
      fee: 445,
      feeType: "Appearance committal mention/case conference",
      table: "Table E",
      note: "Magistrates' Court stage of an indictable crime matter.",
    },
    "Committal Hearing": {
      fee: 1284,
      feeType: "Appearance on contested committal: day 1",
      table: "Table E",
      note: "Day 1 rate for an indictable committal.",
    },
    "Contested Committal Day 1": {
      fee: 1284,
      feeType: "Appearance on contested committal: day 1",
      table: "Table E",
      note: "Day 1 rate for an indictable committal.",
    },
    "Contested Committal Day 2": {
      fee: 1157,
      feeType: "Appearance on contested committal: day 2",
      table: "Table E",
      note: "Day 2 rate for an indictable committal.",
    },
    "Committal Resolving as Plea": {
      fee: 537,
      feeType: "Committal resolving as a plea",
      table: "Table E",
      note: "Committal which resolves as a plea in the Magistrates' Court, heard on a day other than the committal contest.",
    },
    "Plea": {
      fee: 318,
      feeType: "Plea of guilty",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Contest": {
      fee: 1099,
      feeType: "Contest hearing appearance",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Sentence": {
      fee: 318,
      feeType: "Appearance on sentence or adjournment",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Return for Sentence": {
      fee: 318,
      feeType: "Appearance on sentence or adjournment",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Sentence Indication": {
      fee: 318,
      feeType: "Sentence Indication / Plea fee",
      table: "Table A",
      note: "Guilty plea at contest mention rate.",
    },
    "Ground Rules Hearing": {
      fee: 484,
      feeType: "Ground rules hearing (daily appearance fee)",
      table: "Table E",
      note: "Indictable stage appearance.",
    },
    "CISP/Drug Court Mention": {
      fee: 185,
      feeType: "Court Integrated Services Program/Drug Court mention",
      table: "Table A",
      note: "Single accused rate.",
    },
    "ARC ISP Ratification Hearing": {
      fee: 332,
      feeType: "Assessment and Referral Court – Individual Support Plan Ratification hearing",
      table: "Table A",
      note: "Single accused rate.",
    },
    "ARC Review": {
      fee: 185,
      feeType: "Assessment and Referral Court Review Hearing",
      table: "Table A",
      note: "Single accused rate.",
    },
    "Daily appearance fee": {
      fee: 484,
      feeType: "Daily appearance fee",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Daily appearance fee (consolidation)": {
      fee: 579,
      feeType: "Daily appearance fee (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    },
    "Appearance on sentence or adjournment (consolidation)": {
      fee: 369,
      feeType: "Appearance on sentence or adjournment (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    },
    "Contest Mention (consolidation)": {
      fee: 581,
      feeType: "Consolidated contest mention fee",
      table: "Table A",
      note: "More than one contest mention listed that meets guidelines.",
    },
    "Plea heard at contest mention – contest mention fee": {
      fee: 332,
      feeType: "Plea heard at contest mention – contest mention fee",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Plea heard at contest mention – contest mention fee (consolidation)": {
      fee: 581,
      feeType: "Plea heard at contest mention – contest mention fee (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    },
    "Plea heard at contest mention – plea fee": {
      fee: 318,
      feeType: "Plea heard at contest mention – plea fee",
      table: "Table A",
      note: "Single accused summary rate.",
    },
    "Plea heard at contest mention – plea fee (consolidation)": {
      fee: 369,
      feeType: "Plea heard at contest mention – plea fee (consolidation)",
      table: "Table A",
      note: "Consolidated rate.",
    }
  },
  "County Court": {
    "Mention": {
      fee: 297,
      feeType: "Directions hearing / mention / call over",
      table: "Table F",
      note: "General indictable County Court rate.",
    },
    "First Directions Hearing": {
      fee: 476,
      feeType: "First directions hearing",
      table: "Table F",
      note: "County Court first directions hearing.",
    },
    "Directions Hearing / Mention / Callover": {
      fee: 297,
      feeType: "Directions hearing / mention / call over",
      table: "Table F",
      note: "General indictable County Court rate.",
    },
    "Case Conference": {
      fee: 1370,
      feeType: "Appearance at case conference",
      table: "Table F",
      note: "Active Case Management System fee.",
    },
    "Bail Application": {
      fee: 968,
      feeType: "Appearance fee",
      table: "Table C",
      note: "County Court bail application.",
    },
    "Bail Application Preparation Fee": {
      fee: 1030,
      feeType: "Lump sum preparation fee",
      table: "Table C",
      note: "Covers obtaining instructions, preparing the case, and proofing witnesses.",
    },
    "Bail Application Mention / Adjournment": {
      fee: 298,
      feeType: "Mention/adjournment fee",
      table: "Table C",
      note: "County Court bail application mention or adjournment fee.",
    },
    "Plea": {
      fee: 1834,
      feeType: "Appearance fee – first day",
      table: "Table F",
      note: "County Court plea fee, first day.",
    },
    "First day plea (resolves at trial stage)": {
      fee: 1106,
      feeType: "Plea hearing – first day",
      table: "Table F",
      note: "County Court plea after day 1 of trial.",
    },
    "Subsequent day plea (resolves at trial stage)": {
      fee: 638,
      feeType: "Plea hearing – subsequent day",
      table: "Table F",
      note: "County Court plea after day 1 of trial, subsequent day rate.",
    },
    "Sentence": {
      fee: 356,
      feeType: "Sentence",
      table: "Table F",
      note: "County Court plea or trial sentence appearance.",
    },
    "Return for Sentence": {
      fee: 356,
      feeType: "Sentence",
      table: "Table F",
      note: "County Court plea or trial sentence appearance.",
    },
    "Sentence Indication": {
      fee: 1350,
      feeType: "Appearance fee (includes conferences)",
      table: "Table F",
      note: "County Court sentence indication.",
    },
    "Subsequent day Sentence Indication": {
      fee: 638,
      feeType: "Sentence indication – subsequent day",
      table: "Table F",
      note: "County Court sentence indication, subsequent day rate.",
    },
    "Trial (first day)": {
      fee: 2982,
      feeType: "Appearance fee – first day",
      table: "Table F",
      note: "County Court trial first day.",
    },
    "Trial (first day - 20% uplift applicable)": {
      fee: 3578,
      feeType: "Appearance fee – first day where 20% uplift applicable",
      table: "Table F",
      note: "County Court trial first day uplift rate.",
    },
    "Trial (subsequent day)": {
      fee: 1370,
      feeType: "Appearance fee – subsequent day",
      table: "Table F",
      note: "County Court trial subsequent day.",
    },
    "Sentence Appeal Appearance": {
      fee: 968,
      feeType: "Appearance fee",
      table: "Table G",
      note: "County Court sentence appeal appearance fee.",
    },
    "Conviction and Sentence Appeal Daily Appearance": {
      fee: 1087,
      feeType: "Daily appearance",
      table: "Table H",
      note: "County Court conviction and sentence appeal appearance fee.",
    },
    "Appeal Mention": {
      fee: 297,
      feeType: "Mention fee",
      table: "Table H",
      note: "County Court appeal mention fee.",
    },
    "CMIA Appearance and conference": {
      fee: 707,
      feeType: "Appearance and conference",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Mention": {
      fee: 297,
      feeType: "Mention fee",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Judgement": {
      fee: 356,
      feeType: "Judgement",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Hearing (first day)": {
      fee: 2982,
      feeType: "Appearance fee – first day (includes conferences)",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Hearing (subsequent day)": {
      fee: 1370,
      feeType: "Appearance fee – subsequent day",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "Fitness Investigation Day 1": {
      fee: 2982,
      feeType: "Appearance fee – first day",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "Fitness Investigation Subsequent Day": {
      fee: 1370,
      feeType: "Appearance fee – subsequent day",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "SOA Supervision Order Mention / directions": {
      fee: 298,
      feeType: "Mention / directions",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Supervision Order Hearing (first day)": {
      fee: 2501,
      feeType: "Brief (includes conferences)",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Supervision Order Hearing (subsequent day)": {
      fee: 1370,
      feeType: "Subsequent day",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Review Hearing": {
      fee: 1087,
      feeType: "Daily appearance fee",
      table: "Table Z",
      note: "Review brought by a person subject to an order.",
    },
    "SOA Review Mention / directions": {
      fee: 298,
      feeType: "Mention / directions",
      table: "Table Z",
      note: "Review brought by a person subject to an order.",
    },
    "SOA Review Judgement": {
      fee: 356,
      feeType: "Judgement fee",
      table: "Table Z",
      note: "Review brought by a person subject to an order.",
    },
    "Breach Matter Preparation Fee": {
      fee: 1028,
      feeType: "Solicitor preparation",
      table: "Table J",
      note: "County Court breach matter solicitor preparation fee (5.5 hours).",
    },
    "Breach Matter Mention": {
      fee: 297,
      feeType: "Mention",
      table: "Table J",
      note: "County Court breach matter mention fee.",
    },
    "Breach Matter Daily Appearance": {
      fee: 1087,
      feeType: "Daily appearance",
      table: "Table J",
      note: "County Court breach matter appearance fee.",
    },
    "Breach Matter Sentence": {
      fee: 356,
      feeType: "Sentence (if on a different day)",
      table: "Table J",
      note: "County Court breach matter sentence fee.",
    },
    "Special hearing (first day)": {
      fee: 2501,
      feeType: "Appearance fee – first day (includes conferences)",
      table: "Table F",
      note: "County Court Special hearing brief fee.",
    },
    "Special hearing (subsequent day)": {
      fee: 1370,
      feeType: "Appearance fee – subsequent day(s)",
      table: "Table F",
      note: "County Court Special hearing daily fee.",
    },
    "Ground Rules Hearing": {
      fee: 1370,
      feeType: "Ground rules hearing",
      table: "Table F",
      note: "Intermediaries/ground rules hearing fee.",
    },
    "Section 198A Application for hearing": {
      fee: 714,
      feeType: "Application for hearing",
      table: "Table F",
      note: "Section 198A Application fee.",
    },
    "Section 198A Pre-trial examination": {
      fee: 1370,
      feeType: "Pre-trial examination",
      table: "Table F",
      note: "Section 198A pre-trial examination appearance fee.",
    },
    "Case Initiation Notice": {
      fee: 476,
      feeType: "Case Initiation Notice",
      table: "Table F",
      note: "ACMS Case Initiation Notice fee.",
    },
    "ACMS Prep for case conference (instructor)": {
      fee: 714,
      feeType: "Preparation for case conference (instructor)",
      table: "Table F",
      note: "ACMS Prep fee for instructor.",
    },
    "ACMS Counsel prep for case conference": {
      fee: 1612,
      feeType: "Counsel - preparation for case conference",
      table: "Table F",
      note: "ACMS Counsel prep fee.",
    },
    "Trial Readiness Questionnaire Certificate": {
      fee: 476,
      feeType: "Trial Readiness Questionnaire Certificate",
      table: "Table F",
      note: "ACMS Trial Readiness Questionnaire Certificate fee.",
    },
    "Case assessment hearing": {
      fee: 596,
      feeType: "Case assessment hearing",
      table: "Table F",
      note: "ACMS Case assessment hearing fee.",
    },
    "Post-committal negotiations": {
      fee: 714,
      feeType: "Post-committal negotiations",
      table: "Table F",
      note: "Post-committal negotiation fee.",
    },
    "Defence response – first directions hearing": {
      fee: 476,
      feeType: "Defence response – first directions hearing",
      table: "Table F",
      note: "Defence response preparation and appearance.",
    },
    "Application for discontinuance of proceedings": {
      fee: 595,
      feeType: "Application for discontinuance of proceedings",
      table: "Table F",
      note: "Application fee.",
    },
    "Defence response – final directions hearing": {
      fee: 476,
      feeType: "Defence response – final directions hearing",
      table: "Table F",
      note: "Defence response preparation and appearance.",
    },
    "Conference with co-counsel (TCDP)": {
      fee: 714,
      feeType: "Conference with co-counsel (TCDP)",
      table: "Table F",
      note: "Trial Counsel Development Program conference fee.",
    }
  },
  "Supreme Court": {
    "Mention": {
      fee: 407,
      feeType: "Directions hearing / mention / call over",
      table: "Table F",
      note: "General indictable Supreme Court rate.",
    },
    "First Directions Hearing": {
      fee: 652,
      feeType: "First directions hearing",
      table: "Table F",
      note: "Supreme Court first directions hearing.",
    },
    "Directions Hearing / Mention / Callover": {
      fee: 407,
      feeType: "Directions hearing / mention / call over",
      table: "Table F",
      note: "General indictable Supreme Court rate.",
    },
    "Bail Application": {
      fee: 1041,
      feeType: "Appearance fee",
      table: "Table D",
      note: "Supreme Court bail application.",
    },
    "Bail Application Preparation Fee": {
      fee: 1043,
      feeType: "Lump sum preparation fee",
      table: "Table D",
      note: "Covers preparation for Supreme Court bail application (3.5 hours).",
    },
    "Plea": {
      fee: 2504,
      feeType: "Appearance fee – first day",
      table: "Table F",
      note: "Supreme Court plea fee, first day.",
    },
    "First day plea (resolves at trial stage)": {
      fee: 1508,
      feeType: "Plea hearing – first day",
      table: "Table F",
      note: "Supreme Court plea after day 1 of trial.",
    },
    "Subsequent day plea (resolves at trial stage)": {
      fee: 1002,
      feeType: "Plea hearing – subsequent day",
      table: "Table F",
      note: "Supreme Court plea after day 1 of trial, subsequent day rate.",
    },
    "Trial (first day)": {
      fee: 4737,
      feeType: "Appearance fee – first day",
      table: "Table F",
      note: "Supreme Court trial first day.",
    },
    "Trial (first day - 20% uplift applicable)": {
      fee: 5684,
      feeType: "Appearance fee – first day where 20% uplift applicable",
      table: "Table F",
      note: "Supreme Court trial first day uplift rate.",
    },
    "Trial (subsequent day)": {
      fee: 2197,
      feeType: "Appearance fee – subsequent day",
      table: "Table F",
      note: "Supreme Court trial subsequent day.",
    },
    "Sentence": {
      fee: 491,
      feeType: "Sentence",
      table: "Table F",
      note: "Supreme Court plea or trial sentence appearance.",
    },
    "Return for Sentence": {
      fee: 491,
      feeType: "Sentence",
      table: "Table F",
      note: "Supreme Court plea or trial sentence appearance.",
    },
    "CMIA Appearance and conference": {
      fee: 1344,
      feeType: "Appearance and conference",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Mention": {
      fee: 407,
      feeType: "Mention fee",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Judgement": {
      fee: 491,
      feeType: "Judgement",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Hearing (first day)": {
      fee: 4737,
      feeType: "Appearance fee – first day (includes conferences)",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "CMIA Hearing (subsequent day)": {
      fee: 2197,
      feeType: "Appearance fee – subsequent day",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "Fitness Investigation Day 1": {
      fee: 4737,
      feeType: "Appearance fee – first day",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "Fitness Investigation Subsequent Day": {
      fee: 2197,
      feeType: "Appearance fee – subsequent day",
      table: "Table T",
      note: "Crimes (Mental Impairment and Unfitness to be Tried) Act matter.",
    },
    "SOA Emergency Detention Order Hearing": {
      fee: 1050,
      feeType: "Daily appearance fee",
      table: "Table Z",
      note: "Serious Offenders Act emergency detention order matter.",
    },
    "SOA Emergency Detention Order Mention / directions": {
      fee: 408,
      feeType: "Mention / directions",
      table: "Table Z",
      note: "Serious Offenders Act emergency detention order matter.",
    },
    "SOA Emergency Detention Order Judgement": {
      fee: 491,
      feeType: "Judgement fee",
      table: "Table Z",
      note: "Serious Offenders Act emergency detention order matter.",
    },
    "SOA Detention Order Mention / directions": {
      fee: 408,
      feeType: "Mention / directions",
      table: "Table Z",
      note: "Serious Offenders Act detention order matter.",
    },
    "SOA Detention Order Hearing (first day)": {
      fee: 4737,
      feeType: "Brief (includes conferences)",
      table: "Table Z",
      note: "Serious Offenders Act detention order matter.",
    },
    "SOA Detention Order Hearing (subsequent day)": {
      fee: 2197,
      feeType: "Subsequent day",
      table: "Table Z",
      note: "Serious Offenders Act detention order matter.",
    },
    "SOA Detention Order Judgement": {
      fee: 491,
      feeType: "Judgement fee",
      table: "Table Z",
      note: "Serious Offenders Act detention order matter.",
    },
    "SOA Supervision Order Mention / directions": {
      fee: 408,
      feeType: "Mention / directions",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Supervision Order Hearing (first day)": {
      fee: 4074,
      feeType: "Brief (includes conferences)",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Supervision Order Hearing (subsequent day)": {
      fee: 2197,
      feeType: "Subsequent day",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Supervision Order Judgement": {
      fee: 491,
      feeType: "Judgement fee",
      table: "Table Z",
      note: "Serious Offenders Act supervision order matter.",
    },
    "SOA Review Hearing": {
      fee: 2273,
      feeType: "Daily appearance fee",
      table: "Table Z",
      note: "Review brought by a person subject to an order.",
    },
    "SOA Review Mention / directions": {
      fee: 408,
      feeType: "Mention / directions",
      table: "Table Z",
      note: "Review brought by a person subject to an order.",
    },
    "SOA Review Judgement": {
      fee: 491,
      feeType: "Judgement fee",
      table: "Table Z",
      note: "Review brought by a person subject to an order.",
    },
    "Breach Matter Preparation Fee": {
      fee: 2086,
      feeType: "Solicitor preparation",
      table: "Table J",
      note: "Supreme Court breach matter solicitor preparation fee (5.5 hours).",
    },
    "Breach Matter Mention": {
      fee: 407,
      feeType: "Mention",
      table: "Table J",
      note: "Supreme Court breach matter mention fee.",
    },
    "Breach Matter Daily Appearance": {
      fee: 2273,
      feeType: "Daily appearance",
      table: "Table J",
      note: "Supreme Court breach matter appearance fee.",
    },
    "Breach Matter Sentence": {
      fee: 491,
      feeType: "Sentence (if on a different day)",
      table: "Table J",
      note: "Supreme Court breach matter sentence fee.",
    },
    "Special hearing (first day)": {
      fee: 3410,
      feeType: "Appearance fee – first day (includes conferences)",
      table: "Table F",
      note: "Supreme Court Special hearing brief fee.",
    },
    "Special hearing (subsequent day)": {
      fee: 2197,
      feeType: "Appearance fee – subsequent day(s)",
      table: "Table F",
      note: "Supreme Court Special hearing daily fee.",
    },
    "Sentence Indication": {
      fee: 1838,
      feeType: "Appearance fee (includes conferences)",
      table: "Table F",
      note: "Supreme Court sentence indication fee.",
    },
    "Subsequent day Sentence Indication": {
      fee: 1002,
      feeType: "Sentence indication – subsequent day",
      table: "Table F",
      note: "Supreme Court sentence indication, subsequent day rate.",
    },
    "Ground Rules Hearing": {
      fee: 2197,
      feeType: "Ground rules hearing",
      table: "Table F",
      note: "Intermediaries/ground rules hearing fee.",
    },
    "Application to cross-examine witnesses – s198B": {
      fee: 894,
      feeType: "Application to cross-examine witnesses – s198B",
      table: "Table F",
      note: "Supreme Court s198B application fee.",
    },
    "Appearance where witnesses cross-examined – s198B": {
      fee: 2197,
      feeType: "Appearance where witnesses cross-examined – s198B",
      table: "Table F",
      note: "Supreme Court s198B appearance fee per day.",
    },
    "Counsel prep for administrative callover": {
      fee: 652,
      feeType: "Counsel - preparation for administrative callover process",
      table: "Table F",
      note: "Supreme Court Counsel preparation fee.",
    },
    "Case conference": {
      fee: 1838,
      feeType: "Case conference",
      table: "Table F",
      note: "Supreme Court Case conference fee.",
    },
    "Post-committal negotiations": {
      fee: 978,
      feeType: "Post-committal negotiations",
      table: "Table F",
      note: "Post-committal negotiation fee.",
    },
    "Defence response – first directions hearing": {
      fee: 652,
      feeType: "Defence response – first directions hearing",
      table: "Table F",
      note: "Defence response preparation and appearance.",
    },
    "Application for discontinuance of proceedings": {
      fee: 815,
      feeType: "Application for discontinuance of proceedings",
      table: "Table F",
      note: "Application fee.",
    },
    "Defence response – final directions hearing": {
      fee: 652,
      feeType: "Defence response – final directions hearing",
      table: "Table F",
      note: "Defence response preparation and appearance.",
    },
    "Conference with co-counsel (TCDP)": {
      fee: 978,
      feeType: "Conference with co-counsel (TCDP)",
      table: "Table F",
      note: "Trial Counsel Development Program conference fee.",
    }
  },
  "Court of appeal": {
    "Oral hearing (exceptional circumstances)": {
      fee: 326,
      feeType: "Oral hearing (exceptional circumstances)",
      table: "Table K",
      note: "Exceptional circumstances leave application hearing.",
    },
    "Election to renew – Brief fee (first day)": {
      fee: 631,
      feeType: "Brief fee (including first day of appearance)",
      table: "Table K",
      note: "Election to renew leave to appeal.",
    },
    "Election to renew – Subsequent day": {
      fee: 326,
      feeType: "Subsequent day(s)",
      table: "Table K",
      note: "Election to renew leave to appeal.",
    },
    "Election to renew – Appearance at judgment": {
      fee: 491,
      feeType: "Appearance at judgment (if on a different day)",
      table: "Table K",
      note: "Election to renew leave to appeal.",
    },
    "Appeal against sentence – Brief fee": {
      fee: 2269,
      feeType: "Brief fee (includes preparation and appearances)",
      table: "Table K",
      note: "Appeal against sentence.",
    },
    "Appeal against sentence – Subsequent day": {
      fee: 1511,
      feeType: "Subsequent day(s)",
      table: "Table K",
      note: "Appeal against sentence.",
    },
    "Appeal against sentence – Appearance at judgment": {
      fee: 491,
      feeType: "Appearance at judgment (if on a different day)",
      table: "Table K",
      note: "Appeal against sentence.",
    },
    "Appeal against conviction/conviction & sentence – Brief fee": {
      fee: 2269,
      feeType: "Brief fee (includes preparation and appearances)",
      table: "Table K",
      note: "Appeal against conviction/conviction and sentence.",
    },
    "Appeal against conviction/conviction & sentence – Subsequent day": {
      fee: 1511,
      feeType: "Subsequent day(s)",
      table: "Table K",
      note: "Appeal against conviction/conviction and sentence.",
    },
    "Appeal against conviction/conviction & sentence – Appearance at judgment": {
      fee: 491,
      feeType: "Appearance at judgment (if on a different day)",
      table: "Table K",
      note: "Appeal against conviction/conviction and sentence.",
    },
    "Leave application – Preparation": {
      fee: 596,
      feeType: "Leave application – preparation",
      table: "Table K",
      note: "Leave application preparation fee.",
    },
    "Drawing grounds of appeal & written case (conviction / conviction & sentence)": {
      fee: 1630,
      feeType: "Drawing grounds of appeal and written case",
      table: "Table K",
      note: "Conviction / conviction and sentence appeal.",
    },
    "Drawing grounds of appeal & written case (sentence only)": {
      fee: 978,
      feeType: "Drawing grounds of appeal and written case (sentence only)",
      table: "Table K",
      note: "Sentence appeal only.",
    },
    "Revision of grounds of appeal": {
      fee: 326,
      feeType: "Revision of grounds of appeal",
      table: "Table K",
      note: "Revision of grounds of appeal.",
    },
    "Application for renewal": {
      fee: 326,
      feeType: "Application for renewal",
      table: "Table K",
      note: "Application for renewal.",
    },
    "Election to renew – Preparation": {
      fee: 298,
      feeType: "Preparation",
      table: "Table K",
      note: "Election to renew leave to appeal.",
    },
    "Perusal of leave application & drawing revised grounds of appeal": {
      fee: 652,
      feeType: "Perusal of leave application and drawing revised grounds of appeal",
      table: "Table K",
      note: "Election to renew leave to appeal.",
    },
    "Appeal against sentence – Solicitor preparation": {
      fee: 894,
      feeType: "Solicitor preparation",
      table: "Table K",
      note: "Appeal against sentence solicitor preparation fee.",
    },
    "Appeal against conviction – Solicitor preparation": {
      fee: 1490,
      feeType: "Solicitor preparation",
      table: "Table K",
      note: "Appeal against conviction solicitor preparation fee.",
    },
  },
  "High Court": {
    "Application for Special Leave": {
      fee: 2269,
      feeType: "Appearance fee",
      table: "Table L",
      note: "High Court special leave application, first day.",
    },
    "Appeal": {
      fee: 2269,
      feeType: "Appearance fee",
      table: "Table L",
      note: "High Court appeal, first day.",
    },
  },
  "Office of Chief Examiner": {
    "Examination": {
      fee: 0,
      feeType: "Coercive Examination appearance fee",
      table: "N/A",
      note: "Special preparation and attendance fee as approved by VLA.",
    }
  }
};

const APPEAL_COSTS_CERTIFICATE_FEE_LOOKUP = {
  "Magistrates Court": {
    "Hearing (Summary Crime)": {
      fee: 484,
      feeType: "Hearing (summary crime) – appearance fee in all matters",
      table: "Table BBB",
      note: "Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Daily appearance fee (consolidation)": {
      fee: 579,
      feeType: "Hearing (summary crime) – consolidation",
      table: "Table BBB",
      note: "Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Contest Mention": {
      fee: 332,
      feeType: "Contest mention (summary crime) – contest mention fee",
      table: "Table BBB",
      note: "Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Committal Mention": {
      fee: 447,
      feeType: "Committal mention – committal mention fee",
      table: "Table BBB",
      note: "Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Contested Committal First Day": {
      fee: 1157,
      feeType: "Contested committal – second day fee",
      table: "Table BBB",
      note: "Appeal Costs Certificate table wording uses the second day fee.",
      certificateFee: true,
    },
    "Contested Committal Day 1": {
      fee: 1157,
      feeType: "Contested committal – second day fee",
      table: "Table BBB",
      note: "Appeal Costs Certificate table wording uses the second day fee.",
      certificateFee: true,
    },
    "Contested Committal Day 2": {
      fee: 1157,
      feeType: "Contested committal – second day fee",
      table: "Table BBB",
      note: "Appeal Costs Certificate rate.",
      certificateFee: true,
    },
  },
  "County Court": {
    "Appeal from Magistrates Court": {
      fee: 968,
      feeType: "Appeal – brief fee",
      table: "Table BBB",
      note: "Per day or part day. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Plea": {
      fee: 638,
      feeType: "Plea – second day fee",
      table: "Table BBB",
      note: "Per day or part day. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Trial": {
      fee: 1370,
      feeType: "Trial, single day adjournment – subsequent day fee",
      table: "Table BBB",
      note: "Counsel rate per day. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Trial (subsequent day)": {
      fee: 1370,
      feeType: "Trial, single day adjournment – subsequent day fee",
      table: "Table BBB",
      note: "Counsel rate per day. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
  },
  "Supreme Court": {
    "Appeal": {
      fee: 2269,
      feeType: "Appeal – brief fee",
      table: "Table BBB",
      note: "Per day or part day. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Plea": {
      fee: 1002,
      feeType: "Plea – second day fee",
      table: "Table BBB",
      note: "Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Trial": {
      fee: 2197,
      feeType: "Trial, single day adjournment – subsequent day fee",
      table: "Table BBB",
      note: "Per day or part day. Counsel rate. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
    "Trial (subsequent day)": {
      fee: 2197,
      feeType: "Trial, single day adjournment – subsequent day fee",
      table: "Table BBB",
      note: "Per day or part day. Counsel rate. Appeal Costs Certificate rate.",
      certificateFee: true,
    },
  },
};

const COUNSEL_TRIAL_FEE_LOOKUP = {
  "County Court": {
    "Mention": {
      feeType: "Directions hearing / mention / callover",
      table: "Table M",
      roles: {
        "Senior Counsel": 545,
        "Senior Junior Counsel": 297,
        "Junior Counsel / Trial Counsel Development Program": 182,
      },
    },
    "First Directions Hearing": {
      feeType: "First directions hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 872,
        "Senior Junior Counsel": 476,
        "Junior Counsel / Trial Counsel Development Program": 292,
      },
    },
    "Directions Hearing": {
      feeType: "Directions hearing / mention / callover",
      table: "Table M",
      roles: {
        "Senior Counsel": 545,
        "Senior Junior Counsel": 297,
        "Junior Counsel / Trial Counsel Development Program": 182,
      },
    },
    "Directions Hearing / Mention / Callover": {
      feeType: "Directions hearing / mention / callover",
      table: "Table M",
      roles: {
        "Senior Counsel": 545,
        "Senior Junior Counsel": 297,
        "Junior Counsel / Trial Counsel Development Program": 182,
      },
    },
    "Plea": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 4025,
        "Senior Junior Counsel": 1834,
        "Junior Counsel / Trial Counsel Development Program": 1086,
      },
    },
    "First day plea (resolves at trial stage)": {
      feeType: "Plea hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 2694,
        "Senior Junior Counsel": 1106,
        "Junior Counsel / Trial Counsel Development Program": 628,
      },
    },
    "Subsequent day plea (resolves at trial stage)": {
      feeType: "Plea hearing – subsequent days",
      table: "Table M",
      roles: {
        "Senior Counsel": 2240,
        "Senior Junior Counsel": 638,
        "Junior Counsel / Trial Counsel Development Program": 501,
      },
    },
    "Sentence": {
      feeType: "Sentence (if on a different day)",
      table: "Table M",
      roles: {
        "Senior Counsel": 661,
        "Senior Junior Counsel": 356,
        "Junior Counsel / Trial Counsel Development Program": 356,
      },
    },
    "Return for Sentence": {
      feeType: "Sentence (if on a different day)",
      table: "Table M",
      roles: {
        "Senior Counsel": 661,
        "Senior Junior Counsel": 356,
        "Junior Counsel / Trial Counsel Development Program": 356,
      },
    },
    "Sentence Indication": {
      feeType: "Brief fee (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 3138,
        "Senior Junior Counsel": 1350,
        "Junior Counsel / Trial Counsel Development Program": 780,
      },
    },
    "Subsequent day Sentence Indication": {
      feeType: "Sentence indication – subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 2240,
        "Senior Junior Counsel": 638,
        "Junior Counsel / Trial Counsel Development Program": 501,
      },
    },
    "Trial": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 6264,
        "Senior Junior Counsel": 2982,
        "Junior Counsel / Trial Counsel Development Program": 1403,
      },
      note: "First-day trial fee.",
    },
    "Trial (first day)": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 6264,
        "Senior Junior Counsel": 2982,
        "Junior Counsel / Trial Counsel Development Program": 1403,
      },
    },
    "Trial (first day - 20% uplift applicable)": {
      feeType: "Brief fee – first day where 20% uplift applicable",
      table: "Table M",
      roles: {
        "Senior Counsel": 7516,
        "Senior Junior Counsel": 3578,
        "Junior Counsel / Trial Counsel Development Program": 1682,
      },
    },
    "Trial (subsequent day)": {
      feeType: "Subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 3364,
        "Senior Junior Counsel": 1370,
        "Junior Counsel / Trial Counsel Development Program": 754,
      },
    },
    "Fitness Investigation Day 1": {
      feeType: "Appearance fee – first day",
      table: "Table M",
      roles: {
        "Senior Counsel": 6264,
        "Senior Junior Counsel": 2982,
        "Junior Counsel / Trial Counsel Development Program": 1403,
      },
    },
    "Fitness Investigation Subsequent Day": {
      feeType: "Subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 3364,
        "Senior Junior Counsel": 1370,
        "Junior Counsel / Trial Counsel Development Program": 754,
      },
    },
    "Special hearing (first day)": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 4934,
        "Senior Junior Counsel": 2501,
        "Junior Counsel / Trial Counsel Development Program": 1249,
      },
    },
    "Special hearing (subsequent day)": {
      feeType: "Subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 3364,
        "Senior Junior Counsel": 1370,
        "Junior Counsel / Trial Counsel Development Program": 754,
      },
    },
    "Post-committal negotiations": {
      feeType: "Post-committal negotiations",
      table: "Table M",
      roles: {
        "Senior Counsel": 1308,
        "Senior Junior Counsel": 714,
        "Junior Counsel / Trial Counsel Development Program": 438,
      },
    },
    "Defence response – first directions hearing": {
      feeType: "Defence response – first directions hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 872,
        "Senior Junior Counsel": 476,
        "Junior Counsel / Trial Counsel Development Program": 292,
      },
    },
    "Application for discontinuance of proceedings": {
      feeType: "Application for discontinuance of proceedings",
      table: "Table M",
      roles: {
        "Senior Counsel": 1090,
        "Senior Junior Counsel": 595,
        "Junior Counsel / Trial Counsel Development Program": 365,
      },
    },
    "Defence response – final directions hearing": {
      feeType: "Defence response – final directions hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 872,
        "Senior Junior Counsel": 476,
        "Junior Counsel / Trial Counsel Development Program": 292,
      },
    },
    "Conference with co-counsel (TCDP)": {
      feeType: "Conference with co-counsel (Trial Counsel Development Program only)",
      table: "Table M",
      roles: {
        "Senior Counsel": 1308,
        "Senior Junior Counsel": 714,
        "Junior Counsel / Trial Counsel Development Program": 438,
      },
    },
  },
  "Supreme Court": {
    "Mention": {
      feeType: "Directions hearing / mention / callover",
      table: "Table M",
      roles: {
        "Senior Counsel": 545,
        "Senior Junior Counsel": 407,
        "Junior Counsel / Trial Counsel Development Program": 206,
      },
    },
    "First Directions Hearing": {
      feeType: "First directions hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 872,
        "Senior Junior Counsel": 652,
        "Junior Counsel / Trial Counsel Development Program": 330,
      },
    },
    "Directions Hearing": {
      feeType: "Directions hearing / mention / callover",
      table: "Table M",
      roles: {
        "Senior Counsel": 545,
        "Senior Junior Counsel": 407,
        "Junior Counsel / Trial Counsel Development Program": 206,
      },
    },
    "Directions Hearing / Mention / Callover": {
      feeType: "Directions hearing / mention / callover",
      table: "Table M",
      roles: {
        "Senior Counsel": 545,
        "Senior Junior Counsel": 407,
        "Junior Counsel / Trial Counsel Development Program": 206,
      },
    },
    "Plea": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 4025,
        "Senior Junior Counsel": 2504,
        "Junior Counsel / Trial Counsel Development Program": 1395,
      },
    },
    "First day plea (resolves at trial stage)": {
      feeType: "Plea hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 2694,
        "Senior Junior Counsel": 1508,
        "Junior Counsel / Trial Counsel Development Program": 880,
      },
    },
    "Subsequent day plea (resolves at trial stage)": {
      feeType: "Plea hearing – subsequent days",
      table: "Table M",
      roles: {
        "Senior Counsel": 2240,
        "Senior Junior Counsel": 1002,
        "Junior Counsel / Trial Counsel Development Program": 735,
      },
    },
    "Sentence": {
      feeType: "Sentence (if on a different day)",
      table: "Table M",
      roles: {
        "Senior Counsel": 661,
        "Senior Junior Counsel": 491,
        "Junior Counsel / Trial Counsel Development Program": 491,
      },
    },
    "Return for Sentence": {
      feeType: "Sentence (if on a different day)",
      table: "Table M",
      roles: {
        "Senior Counsel": 661,
        "Senior Junior Counsel": 491,
        "Junior Counsel / Trial Counsel Development Program": 491,
      },
    },
    "Trial": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 7149,
        "Senior Junior Counsel": 4737,
        "Junior Counsel / Trial Counsel Development Program": 2524,
      },
      note: "First-day trial fee.",
    },
    "Trial (first day)": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 7149,
        "Senior Junior Counsel": 4737,
        "Junior Counsel / Trial Counsel Development Program": 2524,
      },
    },
    "Trial (first day - 20% uplift applicable)": {
      feeType: "Brief fee – first day where 20% uplift applicable",
      table: "Table M",
      roles: {
        "Senior Counsel": 8578,
        "Senior Junior Counsel": 5684,
        "Junior Counsel / Trial Counsel Development Program": 3028,
      },
    },
    "Trial (subsequent day)": {
      feeType: "Subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 3364,
        "Senior Junior Counsel": 2197,
        "Junior Counsel / Trial Counsel Development Program": 1091,
      },
    },
    "Fitness Investigation Day 1": {
      feeType: "Appearance fee – first day",
      table: "Table M",
      roles: {
        "Senior Counsel": 7149,
        "Senior Junior Counsel": 4737,
        "Junior Counsel / Trial Counsel Development Program": 2524,
      },
    },
    "Fitness Investigation Subsequent Day": {
      feeType: "Subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 3364,
        "Senior Junior Counsel": 2197,
        "Junior Counsel / Trial Counsel Development Program": 1091,
      },
    },
    "Special hearing (first day)": {
      feeType: "Brief fee – first day (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 4934,
        "Senior Junior Counsel": 3410,
        "Junior Counsel / Trial Counsel Development Program": 1666,
      },
    },
    "Special hearing (subsequent day)": {
      feeType: "Subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 3364,
        "Senior Junior Counsel": 2197,
        "Junior Counsel / Trial Counsel Development Program": 1091,
      },
    },
    "Sentence Indication": {
      feeType: "Brief fee (includes conferences)",
      table: "Table M",
      roles: {
        "Senior Counsel": 3138,
        "Senior Junior Counsel": 1838,
        "Junior Counsel / Trial Counsel Development Program": 1045,
      },
    },
    "Subsequent day Sentence Indication": {
      feeType: "Sentence indication – subsequent day",
      table: "Table M",
      roles: {
        "Senior Counsel": 2240,
        "Senior Junior Counsel": 1002,
        "Junior Counsel / Trial Counsel Development Program": 735,
      },
    },
    "Post-committal negotiations": {
      feeType: "Post-committal negotiations",
      table: "Table M",
      roles: {
        "Senior Counsel": 1308,
        "Senior Junior Counsel": 978,
        "Junior Counsel / Trial Counsel Development Program": 495,
      },
    },
    "Defence response – first directions hearing": {
      feeType: "Defence response – first directions hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 872,
        "Senior Junior Counsel": 652,
        "Junior Counsel / Trial Counsel Development Program": 330,
      },
    },
    "Application for discontinuance of proceedings": {
      feeType: "Application for discontinuance of proceedings",
      table: "Table M",
      roles: {
        "Senior Counsel": 1090,
        "Senior Junior Counsel": 815,
        "Junior Counsel / Trial Counsel Development Program": 412,
      },
    },
    "Defence response – final directions hearing": {
      feeType: "Defence response – final directions hearing",
      table: "Table M",
      roles: {
        "Senior Counsel": 872,
        "Senior Junior Counsel": 652,
        "Junior Counsel / Trial Counsel Development Program": 330,
      },
    },
    "Conference with co-counsel (TCDP)": {
      feeType: "Conference with co-counsel (Trial Counsel Development Program only)",
      table: "Table M",
      roles: {
        "Senior Counsel": 1308,
        "Senior Junior Counsel": 978,
        "Junior Counsel / Trial Counsel Development Program": 495,
      },
    },
  },
};

const COUNSEL_TYPE_OPTIONS = [
  { value: "n_a", label: "N/A" },
  { value: "Senior Counsel", label: "Senior Counsel" },
  { value: "Senior Junior Counsel", label: "Senior Junior Counsel" },
  { value: "Junior Counsel / Trial Counsel Development Program", label: "Junior Counsel / Trial Counsel Development Program" },
];

const HOURLY_PREPARATION_RATES = {
  "Children's Court (Summary)": {
    "Senior Counsel": 436,
    Counsel: 178,
    Solicitor: 178,
  },
  "Children's Court (Serious Indictable)": {
    "Senior Counsel": 436,
    Counsel: 178,
    Solicitor: 178,
  },
  "Magistrates Court": {
    "Senior Counsel": 436,
    Counsel: 178,
    Solicitor: 178,
  },
  "County Court": {
    "Senior Counsel": 436,
    Counsel: 238,
    Solicitor: 187,
  },
  "Supreme Court": {
    "Senior Counsel": 436,
    Counsel: 326,
    Solicitor: 298,
  },
};

const CMIA_SUPPORTING_RATES = {
  "County Court": {
    preparationHours: 8,
    preparationRate: 187,
    preparationFee: 1496,
    instructingRate: 165,
    instructingMaxHours: 5,
  },
  "Supreme Court": {
    preparationHours: 8,
    preparationRate: 298,
    preparationFee: 2384,
    instructingRate: 298,
    instructingMaxHours: 5,
  },
};

const SOA_SUPPORTING_RATES = {
  "County Court": {
    "SOA Supervision Order Hearing (first day)": {
      preparation: "5 hours at $187 per hour = $935",
      instructing: "$165 per hour, up to 5 hours per day",
    },
    "SOA Review Hearing": {
      preparation: "5 hours at $187 per hour = $935",
      instructing: "",
    },
  },
  "Supreme Court": {
    "SOA Emergency Detention Order Hearing": {
      preparation: "3.5 hours at $298 per hour = $1043",
      instructing: "",
    },
    "SOA Detention Order Hearing (first day)": {
      preparation: "10 hours at $298 per hour = $2980",
      instructing: "$298 per hour, up to 5 hours per day",
    },
    "SOA Supervision Order Hearing (first day)": {
      preparation: "7 hours at $298 per hour = $2086",
      instructing: "$298 per hour, up to 5 hours per day",
    },
    "SOA Review Hearing": {
      preparation: "7 hours at $298 per hour = $2086",
      instructing: "",
    },
  },
};

const CIRCUIT_FEES_BY_TOWN = {
  Ararat: { firstDay: 259, laterDays: 171, overnight: 394 },
  Bairnsdale: { firstDay: 286, laterDays: 190, overnight: 394 },
  Ballarat: { firstDay: 187, laterDays: 126, overnight: 394 },
  Bendigo: { firstDay: 214, laterDays: 141, overnight: 394 },
  Colac: { firstDay: 217, laterDays: 141, overnight: 394 },
  Geelong: { firstDay: 151, laterDays: 98, overnight: 394 },
  Hamilton: { firstDay: 300, laterDays: 197, overnight: 394 },
  Horsham: { firstDay: 300, laterDays: 197, overnight: 394 },
  Kerang: { firstDay: 300, laterDays: 197, overnight: 394 },
  Korumburra: { firstDay: 187, laterDays: 126, overnight: 394 },
  Mildura: {
    firstDay: 363,
    laterDays: 245,
    overnight: 394,
    note: "If the return economy airfare is more than the first day circuit fee, VLA will pay the airfare instead of the first day circuit fee.",
  },
  Morwell: { firstDay: 259, laterDays: 168, overnight: 394 },
  Sale: { firstDay: 259, laterDays: 168, overnight: 394 },
  Shepparton: { firstDay: 247, laterDays: 165, overnight: 394 },
  Wangaratta: { firstDay: 272, laterDays: 185, overnight: 394 },
  Warrnambool: { firstDay: 286, laterDays: 190, overnight: 394 },
  Wodonga: { firstDay: 300, laterDays: 197, overnight: 394 },
};

const CIRCUIT_LOCATION_ALIASES = {
  "Latrobe Valley": "Morwell",
};

const CIRCUIT_FEE_ELIGIBILITY = {
  "Magistrates Court": {
    "Committal Hearing": { feeType: "Circuit fee for contested committal", includeOvernight: true },
    "Contested Committal First Day": { feeType: "Circuit fee for contested committal", includeOvernight: true },
    "Contested Committal Day 1": { feeType: "Circuit fee for contested committal", includeOvernight: true },
    "Contested Committal Day 2": { feeType: "Circuit fee for contested committal", includeOvernight: true },
  },
  "County Court": {
    "Bail Application": { feeType: "Circuit fee for bail hearing", includeOvernight: true },
    "Plea": { feeType: "Circuit fee for plea hearing", includeOvernight: true },
    "First day plea (resolves at trial stage)": { feeType: "Circuit fee for plea hearing", includeOvernight: true },
    "Subsequent day plea (resolves at trial stage)": { feeType: "Circuit fee for plea hearing", includeOvernight: true },
    "Appeal from Magistrates Court": { feeType: "Circuit fee for appeal", includeOvernight: true },
    "Trial": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
    "Trial (first day)": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
    "Trial (first day - 20% uplift applicable)": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
    "Trial (subsequent day)": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
  },
  "Supreme Court": {
    "Bail Application": { feeType: "Circuit fee for bail hearing", includeOvernight: true },
    "Plea": { feeType: "Circuit fee for plea hearing", includeOvernight: true },
    "First day plea (resolves at trial stage)": { feeType: "Circuit fee for plea hearing", includeOvernight: true },
    "Subsequent day plea (resolves at trial stage)": { feeType: "Circuit fee for plea hearing", includeOvernight: true },
    "Trial": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
    "Trial (first day)": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
    "Trial (first day - 20% uplift applicable)": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
    "Trial (subsequent day)": { feeType: "Solicitor out-of-office fee for trial", solicitorOutOfOffice: true },
  },
};

const COUNSEL_CIRCUIT_FEES_BY_TOWN = {
  Ararat: 749,
  Bairnsdale: 1125,
  Ballarat: 373,
  Bendigo: 562,
  Colac: 562,
  Geelong: 187,
  Hamilton: 1125,
  Horsham: 1220,
  Kerang: 1125,
  Korumburra: 373,
  Mildura: 1450,
  Morwell: 562,
  Sale: 843,
  Shepparton: 656,
  Wangaratta: 939,
  Warragul: 373,
  Warrnambool: 1032,
  Wodonga: 1220,
};

const COUNSEL_CIRCUIT_FEE_ELIGIBILITY = {
  "County Court": {
    "Trial": true,
    "Trial (first day)": true,
    "Trial (first day - 20% uplift applicable)": true,
    "Trial (subsequent day)": true,
  },
  "Supreme Court": {
    "Trial": true,
    "Trial (first day)": true,
    "Trial (first day - 20% uplift applicable)": true,
    "Trial (subsequent day)": true,
  },
};

function formatFee(fee) {
  return new Intl.NumberFormat("en-AU", {
    style: "currency",
    currency: "AUD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(fee);
}

function resolveCourtName(courtName) {
  if (courtName === "Children's Court") {
    return "Children's Court (Summary)";
  }
  return courtName;
}

export function getAppearanceTypesForCourt(courtName) {
  const resolved = resolveCourtName(courtName);
  return COURT_APPEARANCE_TYPES[resolved] || COURT_APPEARANCE_TYPES.Other;
}

export function getMatterTypesForAppearanceType(appearanceType) {
  return APPEARANCE_MATTER_TYPES[appearanceType] || [{ label: "Other" }];
}

export function getAppearanceFeeInfo(courtName, appearanceType) {
  const resolved = resolveCourtName(courtName);
  const feeInfo = APPEARANCE_FEE_LOOKUP[resolved]?.[appearanceType];
  if (!feeInfo) return null;

  return {
    ...feeInfo,
    amountLabel: formatFee(feeInfo.fee),
  };
}

export function getAppealCostsCertificateFeeInfo(courtName, appearanceType) {
  let resolvedCourt = resolveCourtName(courtName);
  if (resolvedCourt === "Children's Court (Summary)") {
    resolvedCourt = "Magistrates Court";
  } else if (resolvedCourt === "Children's Court (Serious Indictable)") {
    resolvedCourt = "County Court";
  }

  let resolvedType = appearanceType;
  if (resolvedCourt === "Magistrates Court") {
    if (appearanceType === "Contest") {
      resolvedType = "Hearing (Summary Crime)";
    }
  } else if (resolvedCourt === "County Court" || resolvedCourt === "Supreme Court") {
    if (appearanceType === "Trial (first day)" || appearanceType === "Trial (first day - 20% uplift applicable)" || appearanceType === "Trial") {
      resolvedType = "Trial";
    }
  }

  const feeInfo = APPEAL_COSTS_CERTIFICATE_FEE_LOOKUP[resolvedCourt]?.[resolvedType];
  if (!feeInfo) return null;

  return {
    ...feeInfo,
    amountLabel: formatFee(feeInfo.fee),
  };
}

export function getCounselTrialFeeInfo(courtName, appearanceType) {
  const resolved = resolveCourtName(courtName);
  const feeInfo = COUNSEL_TRIAL_FEE_LOOKUP[resolved]?.[appearanceType];
  if (!feeInfo) return null;

  return {
    ...feeInfo,
    roleFees: Object.entries(feeInfo.roles).map(([role, fee]) => ({
      role,
      fee,
      amountLabel: formatFee(fee),
    })),
  };
}

export function getCounselTypeOptions() {
  return COUNSEL_TYPE_OPTIONS;
}

export function getCircuitFeeInfo(courtName, appearanceType, regionalLocation) {
  const resolved = resolveCourtName(courtName);
  const gazettedTown = CIRCUIT_LOCATION_ALIASES[regionalLocation] || regionalLocation;
  const locationFees = CIRCUIT_FEES_BY_TOWN[gazettedTown];
  const eligibility = CIRCUIT_FEE_ELIGIBILITY[resolved]?.[appearanceType] || {
    feeType: "Circuit fee",
    includeOvernight: true
  };
  if (!locationFees) return null;

  const feeItems = eligibility.solicitorOutOfOffice
    ? [
        {
          label: "Out-of-office fee",
          amount: locationFees.firstDay,
          amountLabel: formatFee(locationFees.firstDay),
        },
        {
          label: "Overnight fee",
          amount: locationFees.overnight,
          amountLabel: formatFee(locationFees.overnight),
        },
      ]
    : [
        {
          label: "First day",
          amount: locationFees.firstDay,
          amountLabel: formatFee(locationFees.firstDay),
        },
        {
          label: "Second and later days",
          amount: locationFees.laterDays,
          amountLabel: formatFee(locationFees.laterDays),
        },
        {
          label: "Overnight fee",
          amount: locationFees.overnight,
          amountLabel: formatFee(locationFees.overnight),
        },
      ];

  return {
    regionalLocation,
    gazettedTown,
    feeType: eligibility.feeType,
    feeItems,
    note: locationFees.note || "",
  };
}

export function getCounselCircuitFeeInfo(courtName, appearanceType, regionalLocation) {
  const resolved = resolveCourtName(courtName);
  const gazettedTown = CIRCUIT_LOCATION_ALIASES[regionalLocation] || regionalLocation;
  const circuitFee = COUNSEL_CIRCUIT_FEES_BY_TOWN[gazettedTown];
  const isEligible = Boolean(COUNSEL_CIRCUIT_FEE_ELIGIBILITY[resolved]?.[appearanceType]) || resolved === "County Court" || resolved === "Supreme Court";
  const overnightFee = CIRCUIT_FEES_BY_TOWN[gazettedTown]?.overnight;
  if (!circuitFee || !isEligible || !overnightFee) return null;

  return {
    regionalLocation,
    gazettedTown,
    feeType: "Counsel circuit fee for each 5-day period or part of trial",
    circuitFee: formatFee(circuitFee),
    overnightFee: formatFee(overnightFee),
    note: "If the trial lasts longer than five sitting days, an additional circuit fee is payable. Overnight fee is also payable if counsel must stay overnight in the circuit town.",
  };
}

export function getCircuitFeesForTown(regionalLocation) {
  if (!regionalLocation) return null;
  const gazettedTown = CIRCUIT_LOCATION_ALIASES[regionalLocation] || regionalLocation;
  const solicitorFees = CIRCUIT_FEES_BY_TOWN[gazettedTown] || null;
  const counselFee = COUNSEL_CIRCUIT_FEES_BY_TOWN[gazettedTown] || null;

  if (!solicitorFees && !counselFee) return null;

  return {
    gazettedTown,
    solicitor: solicitorFees ? {
      firstDay: solicitorFees.firstDay,
      laterDays: solicitorFees.laterDays,
      overnight: solicitorFees.overnight,
      firstDayLabel: formatFee(solicitorFees.firstDay),
      laterDaysLabel: formatFee(solicitorFees.laterDays),
      overnightLabel: formatFee(solicitorFees.overnight),
      note: solicitorFees.note || "",
    } : null,
    counsel: counselFee ? {
      amount: counselFee,
      amountLabel: formatFee(counselFee),
      overnight: solicitorFees?.overnight || 394,
      overnightLabel: formatFee(solicitorFees?.overnight || 394),
    } : null,
  };
}

export function getHourlyPreparationFeeInfo(courtName, appearanceType) {
  const resolved = resolveCourtName(courtName);
  if (!COUNSEL_TRIAL_FEE_LOOKUP[resolved]?.[appearanceType]) return null;

  const rates = HOURLY_PREPARATION_RATES[resolved];
  if (!rates) return null;

  return {
    feeType: "Hourly preparation fees and conferences",
    rates: Object.entries(rates).map(([role, fee]) => ({
      role,
      fee,
      amountLabel: formatFee(fee),
    })),
    note: "Preparation fees are payable to trial counsel only. No preparation fees are available for junior or co-counsel.",
  };
}

export function getCmiaFeeInfo(courtName, appearanceType) {
  const resolved = resolveCourtName(courtName);
  if (!appearanceType.startsWith("CMIA ")) return null;

  const courtRates = CMIA_SUPPORTING_RATES[resolved];
  if (!courtRates) return null;

  return {
    feeType: "Crimes (Mental Impairment and Unfitness to be Tried) Act supporting rates",
    preparation: `${formatFee(courtRates.preparationRate)} per hour for ${courtRates.preparationHours} hours = ${formatFee(courtRates.preparationFee)}`,
    instructing: `${formatFee(courtRates.instructingRate)} per hour, up to ${courtRates.instructingMaxHours} hours per day`,
    note: "These fees may be increased in matters involving a revocation of a supervision order, an order for review, or a major review.",
  };
}

export function getSoaFeeInfo(courtName, appearanceType) {
  const resolved = resolveCourtName(courtName);
  if (!appearanceType.startsWith("SOA ")) return null;

  const supporting = SOA_SUPPORTING_RATES[resolved]?.[appearanceType];
  return {
    feeType: "Serious Offenders Act supporting rates",
    preparation: supporting?.preparation || "",
    instructing: supporting?.instructing || "",
    note: "VLA may allow additional claims for additional preparation by counsel with advance approval.",
  };
}

export function hasDifferentCertificateFee(courtName, appearanceType) {
  const resolved = resolveCourtName(courtName);
  const standardInfo = getAppearanceFeeInfo(resolved, appearanceType);
  const certInfo = getAppealCostsCertificateFeeInfo(resolved, appearanceType);
  return Boolean(certInfo && standardInfo && certInfo.fee !== standardInfo.fee);
}
